import store from "@saas/store/src"; // 导入 store 实例
// 是否是白板和录屏用户
export const isWhiteboardAndRecord = (userId) => {
  return userId.startsWith("whiteboard_") || userId.startsWith("record_");
};

// 判断id 是否是助教
export const isAssistant = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  if (id && roomInfo.assistant_teacher_id_arr) {
    return roomInfo.assistant_teacher_id_arr.includes(id);
  }
  return false;
};

// 判断id 是否是老师
export const isTeacher = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  if (id && roomInfo.teacher_id) {
    return roomInfo.teacher_id === id;
  }
  return false;
};
// 判断id是否是学生
export const isStudent = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  const idList = [
    ...(roomInfo.assistant_teacher_id_arr || []),
    roomInfo.teacher_id,
  ];
  if (idList.includes(id)) {
    return false;
  }
  return true;
};
// 判断是否有操作某人上下台的权限，，助教只能操作学生
export const hasUpDownStagePermission = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  if (roomInfo.isTeacher) {
    // 老师不能操作自己，可以操作其他人包括学生和助教
    return id !== roomInfo.teacher_id;
  } else if (roomInfo.isAssistant) {
    // 助教只能操作学生,不能操作老师和助教
    return isStudent(id, roomInfo);
  } else {
    return false;
  }
};
//
// 判断是否有操作某人麦克风的权限，老师可以操作所有人包括自己，助教只能操作学生和自己
export const hasAudioPermission = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  const userStatus = store.state.live.userStatus;
  if (roomInfo.isTeacher) {
    return true;
  } else if (roomInfo.isAssistant) {
    return id === userStatus.user_id || isStudent(id, roomInfo);
  } else {
    return false;
  }
};

// 判断是否有操作某人摄像头的权限，老师可以操作所有人包括自己，助教只能操作学生和自己
export const hasVideoPermission = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  const userStatus = store.state.live.userStatus;
  if (roomInfo.isTeacher) {
    return true;
  } else if (roomInfo.isAssistant) {
    return id === userStatus.user_id || isStudent(id, roomInfo);
  } else {
    return false;
  }
};
// 判断是否有操作某人白板的权限，老师可以操作所有人包括自己，助教只能操作学生和自己
export const hasWhiteboardPermission = (id, roomInfo) => {
  roomInfo = roomInfo || store.state.live.roomInfo;
  if (roomInfo.isTeacher) {
    // 老师不能操作自己，可以操作其他人包括学生和助教
    return id !== roomInfo.teacher_id;
  } else if (roomInfo.isAssistant) {
    // 助教只能操作学生,不能操作老师和助教
    return isStudent(id, roomInfo);
  } else {
    return false;
  }
};
